import {
  Button,
  Divider,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type FlattenModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onFlatten: () => Promise<void>;
};

export default function FlattenModal({
  isOpen,
  onClose,
  onFlatten,
}: FlattenModalProps): React.ReactElement {
  const [isSubmittingFlatten, setSubmittingFlatten] = useState(false);
  const { t } = useTranslation('table');

  const onFlattenInternal = async () => {
    setSubmittingFlatten(true);
    try {
      await onFlatten();
    } catch (error) {
      console.error('Error while flattening group');
    }
    setSubmittingFlatten(false);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('flatten-items-modal.title')}</ModalHeader>
        <Divider orientation="horizontal" />
        <ModalBody>
          <Text>{t('flatten-items-modal.description')}</Text>
        </ModalBody>
        <Divider orientation="horizontal" />
        <ModalFooter gap={2}>
          <Button
            onClick={onFlattenInternal}
            isLoading={isSubmittingFlatten}
            variant="outline"
            colorScheme="red"
          >
            {t('flatten-items-modal.confirm')}
          </Button>
          <Button colorScheme="gray" onClick={onClose}>
            {t('flatten-items-modal.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
